/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CanDisableOffreRequestDto
 */
export interface CanDisableOffreRequestDto {
    /**
     * 
     * @type {number}
     * @memberof CanDisableOffreRequestDto
     */
    idlieuFormation?: number;
    /**
     * 
     * @type {number}
     * @memberof CanDisableOffreRequestDto
     */
    idmetier?: number;
}

/**
 * Check if a given object implements the CanDisableOffreRequestDto interface.
 */
export function instanceOfCanDisableOffreRequestDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CanDisableOffreRequestDtoFromJSON(json: any): CanDisableOffreRequestDto {
    return CanDisableOffreRequestDtoFromJSONTyped(json, false);
}

export function CanDisableOffreRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CanDisableOffreRequestDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idlieuFormation': !exists(json, 'idlieuFormation') ? undefined : json['idlieuFormation'],
        'idmetier': !exists(json, 'idmetier') ? undefined : json['idmetier'],
    };
}

export function CanDisableOffreRequestDtoToJSON(value?: CanDisableOffreRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idlieuFormation': value.idlieuFormation,
        'idmetier': value.idmetier,
    };
}

